import type { IconProps } from '../create-icon'

export function PlayStationLogo({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      <path d="M8.985 2.596v17.548l3.915 1.261V6.688c0-.69.304-1.151.794-.991.636.181.76.814.76 1.505v5.876c2.441 1.193 4.362-.002 4.362-3.153 0-3.2-1.457-4.703-3.985-5.622C13.38 3.792 11.2 3.069 8.985 2.596Zm11.374 13.375c-1.23.636-2.691.966-2.691.966l-7.083 2.504v2.18l7.428-2.639c.843-.3.97-.69.283-.87-.687-.178-1.932-.108-2.776.192l-4.935 1.792V18.02l.358-.131s1.786-.635 4.3-.917c2.515-.283 5.603.218 5.603 1.77 0 1.514-.59 2.146-1.587 2.63-.083-.007 1.1-2.401 1.1-2.401Zm-17.472 2.03c-2.833-.56-3.3-1.73-2.026-2.408 1.178-.629 3.168-1.109 3.168-1.109l5.489-1.96v2.198l-3.952 1.418c-.843.3-.97.69-.283.87.687.179 1.932.108 2.776-.192l1.459-.527v1.95l-.263.046c-2.54.38-5.237.18-6.368-.286Z" />
    </svg>
  )
}
